import React, { useState } from 'react';
import { Star, Lock, ShieldCheck, Zap, Minus, Plus } from 'lucide-react';
import { clsx } from 'clsx';
export function BuyBox() {
  const [format, setFormat] = useState<'pdf' | 'print'>('pdf');
  const [quantity, setQuantity] = useState(1);
  const handleBuy = () => {
    window.location.href = 'https://newdigitalguide.com/cart/42939863072830:1';
  };
  return <div className="flex flex-col space-y-6" data-id="element-1">
      {/* Header & Title */}
      <div className="space-y-2" data-id="element-2">
        <p className="text-xs font-bold tracking-widest text-brand-rose uppercase" data-id="element-3">
          MÉTODO DE LAS 40 SEMANAS DE CONEXIÓN™
        </p>
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-brand-burgundy leading-tight" data-id="element-4">
          Cómo Conectar con Tu Bebé Antes de Nacer
        </h1>
        <p className="text-lg text-gray-600 leading-relaxed pt-1" data-id="element-5">
          40 Semanas de Amor, Conversaciones y Recuerdos Que Durarán Toda la
          Vida
        </p>
      </div>

      {/* Reviews */}
      <div className="flex items-center gap-2" data-id="element-6">
        <div className="flex text-brand-gold" data-id="element-7">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-8" />)}
        </div>
        <span className="text-sm font-medium text-gray-600 underline decoration-brand-gold/30 underline-offset-4" data-id="element-9">
          +2,300 mamás felices
        </span>
      </div>

      {/* Price */}
      <div className="flex items-end gap-3 pt-2" data-id="element-10">
        <span className="text-3xl font-serif font-semibold text-brand-burgundy" data-id="element-11">
          4.99
        </span>
        <span className="text-lg text-gray-400 line-through mb-1" data-id="element-12">$15.00</span>
        <span className="bg-brand-rose-light/30 text-brand-burgundy text-xs font-bold px-2 py-1 rounded-md mb-1.5" data-id="element-13">
          Oferta de lanzamiento
        </span>
      </div>

      <div className="h-px w-full bg-brand-gold/20 my-2" data-id="element-14"></div>

      {/* Format Selector */}
      <div className="space-y-3" data-id="element-15">
        <div className="flex justify-between items-center" data-id="element-16">
          <label className="text-sm font-semibold text-gray-800" data-id="element-17">Formato</label>
        </div>
        <div className="grid grid-cols-1 gap-3" data-id="element-18">
          <button onClick={() => setFormat('pdf')} className={clsx('p-4 rounded-xl border-2 text-left transition-all duration-200 relative overflow-hidden', format === 'pdf' ? 'border-brand-burgundy bg-brand-rose-light/10 shadow-sm' : 'border-brand-gold/30 bg-white hover:border-brand-rose-light')} data-id="element-19">
            <div className="font-medium text-brand-burgundy" data-id="element-20">
              PDF Descargable
            </div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-21">Acceso inmediato</div>
            {format === 'pdf' && <div className="absolute top-0 right-0 w-0 h-0 border-t-[24px] border-r-[24px] border-t-brand-burgundy border-r-transparent" data-id="element-22">
                <div className="absolute -top-[20px] right-[4px] text-white text-[10px] font-bold" data-id="element-23">
                  ✓
                </div>
              </div>}
          </button>
        </div>
      </div>

      {/* Quantity & CTA */}
      <div className="space-y-4 pt-4" data-id="element-24">
        <div className="flex gap-4" data-id="element-25">
          <div className="flex items-center justify-between border-2 border-brand-gold/30 rounded-xl bg-white px-2 w-32" data-id="element-26">
            <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="p-2 text-gray-500 hover:text-brand-burgundy transition-colors" aria-label="Disminuir cantidad" data-id="element-27">
              <Minus className="w-4 h-4" data-id="element-28" />
            </button>
            <span className="font-medium text-gray-800 w-8 text-center" data-id="element-29">
              {quantity}
            </span>
            <button onClick={() => setQuantity(quantity + 1)} className="p-2 text-gray-500 hover:text-brand-burgundy transition-colors" aria-label="Aumentar cantidad" data-id="element-30">
              <Plus className="w-4 h-4" data-id="element-31" />
            </button>
          </div>

          <button onClick={handleBuy} className="flex-1 bg-brand-burgundy hover:bg-[#63242e] text-white font-semibold rounded-xl py-4 px-6 shadow-lg shadow-brand-burgundy/20 transition-all active:scale-[0.98] flex items-center justify-center gap-2" data-id="element-32">
            QUIERO COMENZAR MI MÉTODO
          </button>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 pt-4 text-xs font-medium text-gray-500" data-id="element-33">
          <div className="flex items-center gap-1.5" data-id="element-34">
            <Lock className="w-4 h-4 text-brand-gold" data-id="element-35" />
            <span data-id="element-36">Pago 100% Seguro</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-37">
            <ShieldCheck className="w-4 h-4 text-brand-gold" data-id="element-38" />
            <span data-id="element-39">Garantía 30 Días</span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-40">
            <Zap className="w-4 h-4 text-brand-gold" data-id="element-41" />
            <span data-id="element-42">Acceso Inmediato</span>
          </div>
        </div>
      </div>
    </div>;
}